import { Typography } from '@mui/material';

/**
 * Red minus in the lead slot. On a deduction the kind matters more than the
 * approval state, so it takes the dot's place rather than sitting beside one.
 */
export const DeductionLead = () => (
  <Typography
    component="span"
    aria-hidden
    variant="caption"
    sx={{ color: 'error.main', fontWeight: 700, lineHeight: 1 }}
  >
    −
  </Typography>
);
